export const EVENT_GUEST_CREATE_REQUEST = 'EVENT_GUEST_CREATE_REQUEST';
export const EVENT_GUEST_CREATE = 'EVENT_GUEST_CREATE';

export const EVENT_GUEST_UPDATE_REQUEST = 'EVENT_GUEST_UPDATE_REQUEST';
export const EVENT_GUEST_UPDATE = 'EVENT_GUEST_UPDATE';
